/**
 * Default-off switches for landing regions that stay in the product
 * and stay off the rendered page.
 *
 * `Landing.view` mounts each region only when its switch is true.
 * Turning either switch on is a later change. Do not flip these values.
 */
export type LandingSwitches = {
  /** News strip. Default off. While false, that region is not mounted and makes no request. */
  newsStrip: boolean;
  /**
   * Feature flag for the testimonials section. Defaults to disabled.
   * While false, that region is not mounted and makes no request.
   */
  testimonials: boolean;
};

export const landingSwitches: LandingSwitches = {
  newsStrip: false,
  testimonials: false,
};
